import { useParams, useLocation } from "react-router-dom";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";

import { BackgroundContact } from "../../components/background";
import Header from "../../components/header";
import Footer from "../../components/footer";
import Spacer from "../../components/spacer";
import Project from "../../components/projectComps/projectDetail";
import { useIsMobile } from "../../utils/isMobile";

import { projects } from "../../data/projects"; // ✅ agora é import nomeado

import "./styles.css";

function ProjectDetails() {
  const { slug } = useParams();
  const { t } = useTranslation();
  const location = useLocation();
  const isMobile = useIsMobile();

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const lang = params.get("lang");
    if (lang && t.language !== lang) {
      t.changeLanguage(lang);
    }
  }, [location.search, t]);

  // Busca o projeto pelo slug
  const project = projects.find((p) => p.slug === slug);

  if (!project) return <p>{t("projectNotFound")}</p>;

  return (
    <div className="App">
      <BackgroundContact />
      <div className="project-page-container">
        <Header />

        <Spacer space={isMobile ? "2" : "6"} />
        <div className="project-page-container-content">
          <Project project={project} />
        </div>
        <Spacer space={isMobile ? "2" : "6"} />
        <Footer />
      </div>
    </div>
  );
}

export default ProjectDetails;
